// extracted by mini-css-extract-plugin
module.exports = {"paymentForm__card":"paymentForm__card-2-JO0","googlepay":"googlepay-3wujM","applepay":"applepay-4FBWt","sbp":"sbp-1Bwga"};